import { Button, Card, Col, Divider, Flex, Input, Row, Space, Statistic, Table } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import AddDebt from 'components/debt/AddDebt';
import AddPayment from 'components/debt/AddPayment';
import CustomerInfoModal from 'components/customer/InfoModal2';
import { formatCurrency } from 'utils/number';

const { Search } = Input;

const DebtListDesktop = ({ viewModel }) => {
  const {
    data,
    setFilterValue,
    onSearch,
    onSaved,
    showCustomer,
    clickPhone,
    showCustomerInfo,
    setShowCustomerInfo,
  } = viewModel;

  const columns = [
    {
      title: 'Khách hàng',
      render: (record) => (
        <Space direction='vertical'>
          <Button type='text' onClick={() => showCustomer(record.id)}>{record.phone}</Button>
          <div>{record.full_name}</div>
        </Space>
      ),
    },
    {
      title: 'Còn nợ',
      sorter: (a, b) => a.debt?.current_debt - b.debt?.current_debt,
      render: (record) => (
        <Space direction='vertical'>
          <div>{formatCurrency(record.debt?.current_debt)}</div>
        </Space>
      ),
    },
    {
      title: 'Thanh toán gần nhất',
      sorter: (a, b) => a.stats?.total_spend - b.stats?.total_spend,
      render: (record) => (
        <Space direction='vertical'>
          <div>
            {record.debt.last_payment_date ? moment(record.debt.last_payment_date).format('DD/MM/YY') : null}
          </div>
          <div>{formatCurrency(record.debt?.last_payment_amount)}</div>
        </Space>
      ),
    },
  ];

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Card style={{ width: '100%' }}>
        <Space direction='vertical' style={{ width: '100%' }}>
          <Search
            placeholder='Số điện thoại hoặc tên'
            onSearch={onSearch}
            onChange={(e) => setFilterValue('info', e.target.value)}
            style={{ width: '100%' }}
          />

          <Divider></Divider>
          <Row gutter={16}>
            <Col span={12}>
              <Statistic title='Tổng số khách hàng' value={data.length} />
            </Col>
            <Col span={12}>
              <Statistic title='Tổng số nợ' value={_.sumBy(data, (item) => item.debt?.current_debt ?? 0)} precision={0} />
            </Col>
          </Row>

          <Flex justify='flex-end' style={{ width: '100%' }}>
            <Space>
              <AddPayment onSaved={onSaved}></AddPayment>
              <AddDebt onSaved={onSaved}></AddDebt>
            </Space>
          </Flex>
        </Space>
      </Card>

      <Card style={{ width: '100%' }}>
        <Table rowKey='id' dataSource={data} columns={columns} />
      </Card>

      <CustomerInfoModal id={clickPhone} open={showCustomerInfo} onClose={() => setShowCustomerInfo(false)}></CustomerInfoModal>
    </Space>
  );
};

export default DebtListDesktop;